import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "m-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "Clubhouse")
], -1)
const _hoisted_2 = { class: "d-flex align-items-center justify-content-evenly flex-wrap" }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center mb-4" }, "Member Benefits", -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" While we await the grand opening of our v1 Memphis Lions Metaclubhouse, drop into the ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Official Discord")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" to ask any questions, create, collaborate, or just hang out with your fellow Lions. Our ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Community")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" is moderated 24 hours a day, 7 days a week, with a professional and knowledgeable pride of Lions. Inside the Discord you will find updates from Memphis, game times, scores, social updates, merchandise prizes, whitelist opportunities, giveaways, and more! The Memphis Lions Discord is the easiest way to stay up to date and ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" #LiveLikeALion! ")
const _hoisted_14 = { class: "d-flex align-items-center justify-content-evenly flex-wrap" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h6", { class: "cta-header" }, "Join the Discord", -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h6", { class: "cta-header" }, "The Metaclub", -1)
const _hoisted_18 = ["src"]

import PageFooter from '@/components/PageFooter.vue';
import CTAButton from '@/components/buttons/CTAButton.vue';
import BackButton from '@/components/buttons/BackButton.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ClubhousePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _createVNode(BackButton),
      _hoisted_1,
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("img", {
            class: "img-thumbnail",
            src: require('@/assets/clubhouse.png'),
            alt: "placeholder"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_b_link, {
              href: "https://discord.com/invite/memphislionsclub",
              target: "_blank",
              rel: "noreferrer noopener"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _hoisted_10,
            _createVNode(_component_b_link, {
              href: "https://discord.com/invite/memphislionsclub",
              target: "_blank",
              rel: "noreferrer noopener"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _hoisted_12,
            _createVNode(_component_b_link, {
              href: "https://twitter.com/search?q=%23LiveLikeALion",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_14, [
        _createVNode(_component_b_link, {
          href: "https://discord.com/invite/memphislionsclub",
          target: "_blank",
          rel: "noreferrer noopener"
        }, {
          default: _withCtx(() => [
            _createVNode(CTAButton, { class: "mt-3" }, {
              header: _withCtx(() => [
                _hoisted_15
              ]),
              image: _withCtx(() => [
                _createElementVNode("img", {
                  class: "cta-image",
                  src: require('@/assets/discord.png'),
                  alt: "MLC"
                }, null, 8, _hoisted_16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(CTAButton, {
          class: "mt-3",
          disabled: true
        }, {
          header: _withCtx(() => [
            _hoisted_17
          ]),
          image: _withCtx(() => [
            _createElementVNode("img", {
              class: "cta-image",
              src: require('@/assets/lock.png'),
              alt: "MLC"
            }, null, 8, _hoisted_18)
          ]),
          _: 1
        })
      ]),
      _createVNode(PageFooter)
    ]),
    _: 1
  }))
}
}

})